import { apiInterface } from '@/api/interfaces'
import AbstractApi from '@/api/abstract'
import { paymentApiReq, paymentApiRes } from './interfaces'

class PaymentApi implements apiInterface.IPaymentApi {
  ctx: AbstractApi

  constructor(ctx: AbstractApi) {
    this.ctx = ctx
  }

  /**
   * TODO Переделать на разные эндпоинты
   */
  createPayment = async (
    params: paymentApiReq.ICreatePaymentOrderReq | paymentApiReq.ICreatePaymentOrderServiceReq
  ): Promise<paymentApiRes.ICreatePaymentRes> => {
    const res = await this.ctx.post<
      paymentApiReq.ICreatePaymentOrderReq | paymentApiReq.ICreatePaymentOrderServiceReq,
      paymentApiRes.ICreatePaymentRes
    >('/payment/create_payment/', params)
    return res.data
  }

  listPayment = async (
    params: paymentApiReq.IListPaymentReq
  ): Promise<paymentApiRes.IListPaymentRes> => {
    const res = await this.ctx.get<paymentApiReq.IListPaymentReq, paymentApiRes.IListPaymentRes>(
      '/payment/list_payment/',
      params
    )
    return res.data
  }

  lastPayment = async (
    params: paymentApiReq.ILastPaymentReq
  ): Promise<paymentApiRes.ILastPaymentRes> => {
    const res = await this.ctx.get<paymentApiReq.ILastPaymentReq, paymentApiRes.ILastPaymentRes>(
      '/payment/list_payment/',
      params
    )
    return res.data
  }

  returnPayment = async (
    params: paymentApiReq.IReturnPaymentReq
  ): Promise<paymentApiRes.IReturnPaymentRes> => {
    const res = await this.ctx.post<
      paymentApiReq.IReturnPaymentReq,
      paymentApiRes.IReturnPaymentRes
    >('/payment/return/', params)
    return res.data
  }

  returnCertificate = async (params: paymentApiReq.IReturnCertificateReq): Promise<void> => {
    await this.ctx.post<paymentApiReq.IReturnCertificateReq, void>(
      '/payment/return_certificate/',
      params
    )
  }

  returnDeposit = async (params: paymentApiReq.IReturnDepositReq): Promise<void> => {
    await this.ctx.post<paymentApiReq.IReturnDepositReq, void>('/payment/return_deposit/', params)
  }

  returnMoneyDeposit = async (
    params: paymentApiReq.IReturnMoneyDepositReq
  ): Promise<paymentApiRes.IReturnMoneyDepositRes> => {
    const res = await this.ctx.post<
      paymentApiReq.IReturnMoneyDepositReq,
      paymentApiRes.IReturnMoneyDepositRes
    >('/payment/return_moneydeposit/', params)
    return res.data
  }
}

export default PaymentApi
